import React, { useEffect, useState } from 'react';
import { computeElapsedSeconds, formatHms } from '@/lib/timeEntriesData';

/**
 * Live timer that ticks every second based on the passed `entry` prop.
 *
 * `entry` is the Supabase row shape: { clock_in_at, breaks, current_break_start, ... }
 * — or null if the crew member is off the clock.
 *
 * Phase 16: previously this component re-read localStorage every tick to
 * support the local-only clock state. Now state is owned by the parent
 * (ClockCard) which fetches from Supabase, so we just derive elapsed time
 * from the entry prop.
 */
export const LiveTimer = ({ entry, className = '', testId }) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => (t + 1) % 1_000_000);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const clockInIso = entry?.clock_in_at || entry?.clockInAt;
  if (!clockInIso) {
    return (
      <span
        className={`font-mono tabular-nums text-muted-foreground ${className}`}
        data-testid={testId}
      >
        00:00:00
      </span>
    );
  }

  const seconds = computeElapsedSeconds(entry);
  return (
    <span
      className={`font-mono tabular-nums ${className}`}
      data-testid={testId}
    >
      {formatHms(seconds)}
    </span>
  );
};

export default LiveTimer;
